export const DEFAULT_COUNTRY = "AR";

export const COUNTRIES = {
  AR: "Argentina",
  BO: "Bolivia",
  BR: "Brazil",
  CL: "Chile",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  EC: "Ecuador",
  ES: "España",
  GQ: "Guinea Ecuatorial",
  MX: "México",
  PA: "Panamá",
  PE: "Perú",
  PY: "Paraguay",
  US: "United States",
  UY: "Uruguay",
  VE: "Venezuela",
};

export const LOCALES = {
  AR: "es-AR",
  BO: "es-BO",
  BR: "pt-BR",
  CL: "es-CL",
  CO: "es-CO",
  CR: "es-CR",
  CU: "es-CU",
  EC: "es-EC",
  ES: "es-ES",
  GQ: "es-GQ",
  MX: "es-MX",
  PA: "es-PA",
  PE: "es-PE",
  PY: "es-PY",
  US: "en-US",
  UY: "es-UY",
  VE: "es-VE",
};

export const CURRENCIES = {
  AR: "ARS",
  BO: "BOB",
  BR: "BRL",
  CL: "CLP",
  CO: "COP",
  CR: "CRC",
  CU: "CUC",
  EC: "USD",
  ES: "EUR",
  GQ: "XAF",
  MX: "MXN",
  PA: "USD",
  PE: "PEN",
  PY: "PYG",
  US: "USD",
  UY: "UYU",
  VE: "VEF",
};
